import { render, staticRenderFns } from "./wtpp_applications.vue?vue&type=template&id=13995b22&"
import script from "./wtpp_applications.vue?vue&type=script&lang=js&"
export * from "./wtpp_applications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports